<template>
  <div class="p15 bacf borr10">
    <div class="fontw font16">热门问答</div>
    <div v-for="(item, index) in newList" :key="index" class="mt10">
      <p class="overh newTitle curp" @click="detail(item.guid)">
        {{ item.questiontitle }}
      </p>
      <div class="mt10 clearfix">
        <span class="fl c99">{{ item.commentamount }}人参与互动</span>
        <span class="fr c99">{{ item.fbdate ? item.fbdate.split(" ")[0] : "" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      this.$get(
        `${this.$store.state.api.webUrl}/question/hotanswerlist.json`,
        {
          limit: 5,
        },
        (data) => {
          that.newList = data;
        }
      );
    },
    detail(guid) {
      this.$router.push({
        path: "/everydayQuestion/questionInfo?guid=" + guid,
      });
    },
  },
};
</script>

<style scoped>
.newTitle:hover {
  color: #409eff;
}
</style>
